/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "declined-outline",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "none",
                "stroke": "#AAAAAA",
                "strokeMiterlimit": "10"
            },
            "declinedOutline": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "20",
            "height": "20"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", className: "declined-outline", width: this.props.width, height: this.props.height, style: this.props.declinedOutline },
            _react2["default"].createElement("path", { className: "st0", d: "M17.5 19.5c-.5 0-1-.2-1.4-.6L10 12.8l-6.1 6.1c-.8.8-2.1.8-2.8 0-.4-.4-.6-.9-.6-1.4s.2-1 .6-1.4L7.2 10 1.1 3.9c-.8-.8-.6-2.2 0-2.8.8-.8 2-.8 2.8 0L10 7.2l6.1-6.1c.8-.8 2.1-.8 2.8 0 .4.4.6.9.6 1.4s-.2 1-.6 1.4L12.8 10l6.1 6.1c.4.4.6.9.6 1.4s-.2 1-.6 1.4c-.4.4-.9.6-1.4.6z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/declined-outline.js